import './MGCardList.css'
import MGModalityCardDetail from '../MGModalityCardDetail/MGModalityCardDetail';

export default function MGCardList({ items, leftTitle, rightTitle, rightColor = "#222324" }) {
    return (
        <div className="MGCardList-card-list">
            {items.map((item, index) => (
                item.subscriptionsNumber > 0 && (
                    < MGModalityCardDetail
                        key={item.productID}
                        title={item.productName}
                        leftTitle={leftTitle}
                        rightTitle={rightTitle}
                        rightColor={rightColor}
                        leftAmount={
                            item.productID !== "7365"
                                ? item.totalAmounts.totalInvestedAmount ?? item.totalAmounts.totalCurrentAmount
                                : ""
                        }
                        rightAmount={
                            item.productID !== "7365"
                                ? item.totalAmounts.totalReceivedAmount ?? item.totalAmounts.totalPaidAmount
                                : ""
                        }
                        subscriptionsNumber={item.subscriptionsNumber}
                    />
                )
            ))}
        </div>
    );
}